module.exports = __webpack_public_path__ + "media/images/products/cards/high_alpha-51a66112b6b2943f131a6b94798224fc.png";